import { getCachedViewSnapshot } from '@databases/database-state/state/view';

import { selectDatabaseDraftByContentId } from './changesets/selectors.ts';
import { type DefaultRootState } from './redux.ts';

export const getDatabaseWithCurrentView = (
  state: DefaultRootState,
  { contentId }: { contentId: string }
) => {
  const cachedView = getCachedViewSnapshot();
  return selectDatabaseDraftByContentId(state, {
    contentId,
    cacheKey: 'view',
    includeDeleted: true,
    viewSettings: cachedView.settings
  });
};

export const selectFieldIdsByContentId = (
  state: DefaultRootState,
  { contentId }: { contentId: string }
) => {
  const database = getDatabaseWithCurrentView(state, {
    contentId
  });
  return database.fields;
};
